var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBoy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 43.86 91.66",
    width: "1em",
    height: "1em",
    fill: "currentColor"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".Boy_svg__cls-1{color:${color}}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "Boy_svg__cls-1",
    d: "M0 53.53c1-3 2-5.91 3-8.87 1.72-5.19 3.41-10.39 5.12-15.58.82-2.5 2.13-3.52 4.78-3.53q9-.06 18 0a4.55 4.55 0 014.79 3.56q3.88 11.77 7.76 23.55a4.49 4.49 0 01.11 3.34A3.81 3.81 0 0140 58.43a3.63 3.63 0 01-3.65-2.24c-.71-1.56-1.25-3.2-1.86-4.81l-.36-.92h-.28V85.76a5.45 5.45 0 01-3.29 5.45 5.28 5.28 0 01-7.24-3.62 8.78 8.78 0 01-.2-2.11V63.87c-.17-.09-.22-.15-.28-.15-2.12-.15-2.12-.15-2.12 2v20.17A5.33 5.33 0 0110.12 87a16 16 0 01-.1-1.82Q10 69 10 52.91v-2.53h-.24c-.49 1.33-1 2.67-1.49 4-.2.54-.38 1.09-.62 1.61a3.81 3.81 0 01-3.72 2.48 3.86 3.86 0 01-3.66-2.59c-.08-.18-.18-.35-.27-.52zM33.55 11.51a11.5 11.5 0 01-23-.49 11.51 11.51 0 0123 .49z"
  })))));
}

export default SvgBoy;